import React, { PropsWithChildren } from 'react';
import { CustomArrowProps, Settings } from 'react-slick';

import { carouselBreakpointLg, carouselBreakpointMd, carouselBreakpointXl } from '~/styles';

import { useHasMounted } from '../../hooks';
import { IconNext, IconPrev } from '../../icons';

const svgProps = {
  width: '13px',
  height: '25px',
  stroke: '#ff642e',
  strokeWidth: '2px',
};

interface ArrowProps {
  next?: boolean;
  onClick?: void;
  sizeData: {
    sm: Settings;
    md: Settings;
    lg: Settings;
    xl: Settings;
  };
}

const getCurrentBreakpoint = () => {
  const currentWidth = window.screen.width;
  if (currentWidth < carouselBreakpointMd) {
    return 'sm';
  }
  if (currentWidth < carouselBreakpointLg && currentWidth >= carouselBreakpointMd) {
    return 'md';
  }
  if (currentWidth < carouselBreakpointXl && currentWidth >= carouselBreakpointLg) {
    return 'lg';
  }
  if (currentWidth >= carouselBreakpointXl) {
    return 'xl';
  }
  return 'lg';
};

// Must define arrow custom arrow component to prevent react-slick props bug (see issue #623)
// TODO it looks like this bug is resolved 5 years ago, try to rid of this custom implementation
export const SliderArrow: React.FC<PropsWithChildren<ArrowProps & CustomArrowProps>> = ({
  next = false,
  onClick = () => undefined,
  currentSlide,
  slideCount,
  sizeData,
}) => {
  const { hasMounted } = useHasMounted();
  if (!hasMounted) return null;
  const dataFromSize = sizeData[getCurrentBreakpoint()];
  const slidesToShow = dataFromSize.slidesToShow;
  const slidesToShowData = slidesToShow !== undefined ? slidesToShow : 1; // Used to fix TS lint errors

  const remainingSlides =
    (currentSlide !== undefined ? currentSlide : 0) + 1 + (slidesToShowData - 1);

  // Temporary solution to hide arrows at mobile breakpoint
  // @TODO Hide arrows on mobile devices only
  if (getCurrentBreakpoint() === 'sm') return null;
  return (
    <button
      style={{
        display:
          !next && currentSlide === 0
            ? 'none'
            : next && remainingSlides >= (slideCount !== undefined ? slideCount : 1) // Fixes TS lint error
            ? 'none'
            : undefined,
      }}
      onClick={onClick}
      aria-label={next ? 'Next' : 'Previous'}
      className={`slick-arrow slick-${next ? 'next' : 'prev'}`}
      type="button"
    >
      {next ? (
        <IconNext {...svgProps} style={{ marginRight: '-3px' }} />
      ) : (
        <IconPrev {...svgProps} style={{ marginLeft: '-3px' }} />
      )}
    </button>
  );
};
